import React, {useCallback, useEffect, useState} from "react";
import Good from "./type/Good";
import Type from "./type/Type";
import general, {redux} from "../../general";
import KeepScroll from "../../lib/KeepScroll";
import $ from "jquery";
import Dialog from "../../lib/Dialog";
import Active from "../../lib/active/Active";
import {useMount, useScroll} from "ahooks";
import useActiveState from '../../lib/useActiveState';
import Manager from "../components/Manager";
import useUrlState from "@ahooksjs/use-url-state";
import { useLocation } from 'react-router-dom';

export default ({active, type}) => {
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [init, setInit] = useState(false);
  const [tags, setTags] = useState([]);
  const [tag, setTag] = useState('good');
  const [params, setParams] = useUrlState({}, {navigateMode: 'replace'});

  const load = () => {
    // Dialog.loading();
    // location [1:发现， 2：开服， 3：交易]
    let tmp = {};
    tmp.location = 1;

    general.axios.post('/base/game/getClassifyList', tmp)
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        let tags = data.game_classify_list[0].sub_classify_list[0];
        setTags(tags.map(type => ({id: type.game_classify_id, name: type.game_classify_name, event_id:type.event_id})));
        setTag(tags[0].game_classify_id);
        setInit(true);
        selectOption();
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }

  // useMount(() => load());

  useEffect(() => {
    if (active && !init) {
      load();
    }
  }, [active, init]);

  const tagRef = useCallback(node => {
    if (node) {
      if (
        node.parentNode.scrollTop + node.parentNode.offsetHeight < node.offsetTop
        || node.parentNode.scrollTop + node.parentNode.offsetHeight + node.offsetHeight > node.offsetTop
      ) {
        $(node.parentNode).animate({scrollTop: node.offsetTop - node.parentNode.offsetHeight / 2}, 555);
        node.parentNode.scrollTop = node.offsetTop - node.parentNode.offsetHeight / 2;
      }
    }
  }, []);

  const usePageVisibility=(onVisible,onHidden)=>{
    useEffect(()=>{
      const handlevisibilitychange =()=>{
        if(document.visibilityState == "visible"){
          onVisible && onVisible();
        } else {
          onHidden && onHidden();
        }
      }
      document.addEventListener("visibilitychange", handlevisibilitychange);
      return()=>{
        document.removeEventListener("visibilitychange",handlevisibilitychange);
      };
    },[onVisible, onHidden]);
  }
  const getUrlParams = (url)=>{
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
      // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
          // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramTag = searchParams.get('tag');

  useEffect(()=>{
    if (paramTag) {
      tags.map((item,index)=>{
        if(parseInt(item.id) == parseInt(paramTag)){
          setTag(item.id);
          setRouterIndex(index);
          clickTheCategories(item)
        }
      })
    }
  },[paramTag])

  usePageVisibility(()=>{
    const tag = getUrlParams(window.location.href)['tag']
    if (tag){
      tags.map((item,index)=>{
        if(parseInt(item.id) == parseInt(tag)){
          setTag(item.id);
          setRouterIndex(index);
          clickTheCategories(item)
        }
      })
    }
  },()=>{
    
  })

  const selectOption = () => {
    let tag = redux.getState().screenRouter?.tag;
    // console.log(redux.getState().screenRouter);
    if (tag) {
      setTag(tag);
    }

    tags.map((item,index)=>{
      if(parseInt(item.id) == parseInt(params.tag)){
        setTag(item.id);
        setRouterIndex(index);
        clickTheCategories(item)
      }
    })
    // redux.subscribe(() => {
    //   let tag = redux.getState().screenRouter?.tag;

    //   if (tag) {
    //     setTag(tag);
    //   }
    // });
  }

  useEffect(() => {
    selectOption();
  }, []);

  useEffect(() => {
    redux.subscribe(() => {
      let tag = redux.getState().screenRouter?.tag;
      if (tag) {
        setTag(tag);
        setTimeout(()=>{
          const type = document.getElementsByClassName('type active ')[0]
          type.scrollIntoView(true)
        },100)
      }
    });
  }, []);

  useEffect(() => {
    selectOption();
  }, [tags]);

  // console.log(tag);
  // console.log(tags);
  // console.log(redux.getState().screenRouter);

  //分类点击 埋点
  const clickTheCategories = (item) => {
    Manager.push({event_id:item.event_id})
  }

  //圆角ID处理
  const [routerIndex, setRouterIndex] = useState(0);
  return <div className="game-index-type">
    <div className="types">
      {/* <div className={'type ' + (tag == 'good' ? 'active ' : '') + (routerIndex - 1 == -1 ? 'prevItem ' : '')} onClick={() => {setTag('good');setRouterIndex(-1);clickTheCategories("精选")}}>精选</div> */}
      {tags.map((item,index) => <div
        className={'type ' + (tag == item.id ? 'active ' : '') + (routerIndex - 1 == index ? 'prevItem ' : (routerIndex + 1 == index ? 'nextItem ' : ''))}
        onClick={() => {
          setTag(item.id);
          setRouterIndex(index);
          clickTheCategories(item)
        }}
        ref={type == item.id ? tagRef : null}
      >{item.name}</div>)}
    </div>
    <div className="mains">
      <div className={'main ' + (tag == 'good' || tag == '1000' ? 'active' : '')}>
        {type == 1
          ? <Active active={active && (tag == 'good' || tag == '1000')}>
            <Good active={active && (tag == 'good' || tag == '1000')} type={type} setTag={setTag}/>
          </Active>
          : <Active active={active && (tag == 'good' || tag == '1000')}>
            <Type active={active && (tag == 'good' || tag == '1000')} type={type}/>
          </Active>
        }
      </div>
      {tags.map(item => <div className={'main ' + ((tag == item.id && tag != '1000') ? 'active' : '')}>
        <Active active={active && (tag == item.id && tag != '1000')}>
          <Type active={active && (tag == item.id && tag != '1000')} type={type} tag={item.id}/>
        </Active>
      </div>)}
    </div>
  </div>;
};